import {AttributeLink, AttributeSetup, task} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';
import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';
import {Actor} from '../../layout/context/list.js';
import {ctxMatches} from '../context/list';
import {AmateurUpgrade, CreatorTemplateConfig} from 'acng/amateurPool/service/template';
import {get} from 'acng/amateurPool/service/cache.js';
import {feature} from '../service/template.js';
import {STYLE_EMPTY, swapClass} from 'acng/layout/service/style.js';
import {setup} from '../service/match.js';

/**
 * @group DOM Attribute
 */
const name = 'match-list';

AttributeSetup(name, () => {
  const provide = Actor();
  const watch = Watch(`[${name}]`, ctxMatches);

  AttributeLink(name, (element) => {
    watch(element, (element, list) => {
      swapClass(element, STYLE_EMPTY, !list.length);
      provide(
        element,
        async () => [],
        async (amateur_id) => {
          const amateur = await get(amateur_id);
          const config = CreatorTemplateConfig(amateur);
          config.image = amateur.getMatchMakerImageUrl('800');
          return AmateurUpgrade(amateur, config);
        },
        [...list],
      );
    });
  });

  return (element, value, compiler) => {
    if (feature[HIDDEN]) {
      remove(element);
    } else {
      task(compiler, setup());
    }
  };
});

export {name as MATCH_LIST};
